export interface IUpdateCategoryBoxesWebSettings {
    title: string;
    homepage_hide_category_boxes: number;
    label_position_categories: string;
    colour_category_images_overlay_background: string;
    colour_category_images_overlay_text: string;
}
